import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Config from "../config";

import Observer from "../utils/observer";
import TicketLogic from "../utils/ticket-logic";
import { EmptyRecordsMessage, Pagination, Row } from "../utils/table-utils";
import { OUTCOMES_STATUS } from "../utils/ticket-statuses";

import CashoutService from "../../../services/cashout";
import LFeed from "../../../services/live-feed";

import * as C from "../desktop-templates/cashout-enhanced";
import User from "../../../services/user";
import {
    CashoutPage as AwrabetCashoutPage,
    CashoutBetsTable as AwrabetCashoutBetsTable,
    CashoutBetsTableRow as AwrabetCashoutBetsTableRow
} from '../../awrabet/desktop-components/cashout-enhanced.jsx';

export default function CashoutEnhanced() {
    return <div class="rounded-lg">{/*overflow-hidden*/}
        <div class="p-3 bg-custom-orange text-slate-950 h-10 uppercase text-base"><Trans>Cashout</Trans>
            <div class="hidden rounded-lg bg-slate-50 text-slate-950 text-xl py-2 px-3"></div>
        </div>
        <CashoutPage />
    </div>;
}


export class CashoutPage extends AwrabetCashoutPage {
    render() {
        const tabs = this.state.tabs.list;
        const onSwitchTab = tabKey => this.switchTabs(tabKey);
        const currentTabKey = this.state.tabs.current;

        return <div>
            <C.CashoutTabsContainer>
                {Object.entries(tabs).map(([tabId, item]) => (
                    <C.CashoutTab selected={tabId === currentTabKey} onSwitchTab={() => onSwitchTab(tabId)} name={item.label} />
                ))}
            </C.CashoutTabsContainer>
            <CashoutBetsTable
                {...this.state.response}
                onIdClick={ticket => TicketLogic.printTicket(ticket)}
                onAutoCashout={this.performFullUpdate}
                onPartialCashout={this.performFullUpdate} />
        </div>;
    }
}

export class CashoutBetsTable extends AwrabetCashoutBetsTable {
    render({ data, onIdClick = null, onAutoCashout, onPartialCashout }) {
        return <div>
            <div>
                {!this.state.data.length ?
                    <EmptyRecordsMessage />
                    : <Fragment>
                        <C.BetsTable>
                            <C.BetsTableHeader>
                                <tr>
                                    <C.BetsHeadCell><Trans>ID</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>Tipo Scommessa</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>Cashout</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>Puntata</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>N. Eventi</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>Quota Totale</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell><Trans>Vincita Potenziale</Trans></C.BetsHeadCell>
                                    <C.BetsHeadCell />
                                </tr>
                            </C.BetsTableHeader>
                            {this.state.data.map(bet => <CashoutBetsTableRow row={bet} onIdClick={onIdClick} onAutoCashout={onAutoCashout} onPartialCashout={onPartialCashout} />)}
                        </C.BetsTable>
                        {!!this.state.onNavigation && <Pagination
                            pages={this.state.totalpages}
                            currentPage={this.state.page}
                            onNavigation={page => { this.state.onNavigation(page, page * this.state.recordperpage - this.state.recordperpage) }}
                            isLastPage={this.state.totalpages === this.state.page}
                        />}
                    </Fragment>}
            </div>
        </div>;
    }
}

export class CashoutBetsTableRow extends AwrabetCashoutBetsTableRow {
    render({ row, onIdClick = null, onAutoCashout, onPartialCashout }) {
        const eventipresi = row.odds.filter(o => !!o.status && o.status !== 'L' && o.status !== 'P').length;
        const quotatotale = Math.floor(row.odds.reduce((odds, o) => odds * (CashoutService.getUpdatedOdd(o.id) || o.value), 1) * 100) / 100;

        const ticket = row;
        const cashoutAmountPreview = CashoutService.calculateCashoutWin(ticket);
        const isCashoutAllowed = !!cashoutAmountPreview;

        const isTicketOpen = this.state.showdetails;

        const onCashoutRequest = () => this.confirmCashoutInfo(ticket)
        const onToggleTicketBody = () => this.setState({ showdetails: !isTicketOpen })

        return <C.TicketSummary
            row={row}
            ticket={ticket}
            onIdClick={onIdClick}
            onCashoutRequest={onCashoutRequest}
            isCashoutAllowed={isCashoutAllowed}
            cashoutAmountPreview={cashoutAmountPreview}
            eventipresi={eventipresi}
            quotatotale={quotatotale}
            isTicketOpen={isTicketOpen}
            onToggleTicketBody={onToggleTicketBody}
            onAutoCashout={onAutoCashout}
            onPartialCashout={onPartialCashout}
        >
            <C.TicketTable>
                {isTicketOpen && ticket.odds.map(outcome => {
                    const item = outcome;

                    const dateFormat = CashoutBetsTableRow.printDateFormat(item.date);
                    const statusDescription = CashoutBetsTableRow.outcomeStatusDescription(item.status);

                    const currentOdds = CashoutService.getUpdatedOdd(item.id);
                    const showLiveOdds = item.date <= Date.now();
                    const liveEvent = LFeed.getEvent('/event/' + item.id.split('-').slice(-3)[0]);

                    return <C.TicketSelectionTemplate
                        item={outcome}
                        dateFormat={dateFormat}
                        statusDescription={statusDescription}
                        currentOdds={currentOdds}
                        showLiveOdds={showLiveOdds}
                        liveEvent={liveEvent} />;
                })}
            </C.TicketTable>
        </C.TicketSummary>
    }
}